import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { contactUsReducer, ContactUsState } from './contact-us.reducer';

export interface StaticPagesState {
  contactUs: ContactUsState;
}

export const reducers: ActionReducerMap<StaticPagesState> = {
  // @ts-ignore
  contactUs: contactUsReducer,
};

export const getStaticPagesState =
  createFeatureSelector<StaticPagesState>('staticPages');
